export const CLEARING_HOUSE_NAME_MAX_LETTERS = 255;
export const nameValidator = (t) => (input) => {
    let err = null;
    if (!input || !input.trim().length) {
        err = t('clearing-houses.validation.clearing-house-empty-name');
    } else if (input.trim().length > CLEARING_HOUSE_NAME_MAX_LETTERS) {
        err = t('clearing-houses.validation.clearing-house-name-too-long', { maxLetters: CLEARING_HOUSE_NAME_MAX_LETTERS });
    }
    return err;
};

export const CLEARING_HOUSE_CODE_MAX_LETTERS = 5;
const ALLOWED_ASCII_CHARS = /[\x20-\x7F]+$/;
export const codeValidator = (t) => (input) => {
    let err = null;
    if (!input || !input.trim().length) {
        err = t('clearing-houses.validation.clearing-house-empty-code');
    } else if (input.trim().length > CLEARING_HOUSE_CODE_MAX_LETTERS) {
        err = t('clearing-houses.validation.clearing-house-code-too-long', { maxLetters: CLEARING_HOUSE_CODE_MAX_LETTERS });
    } else if (!ALLOWED_ASCII_CHARS.test(input)) {
        err = t('clearing-houses.validation.clearing-house-invalid-code');
    }
    return err;
};

export const defaultCashLimitValidator = (t, minCashLimit, maxCashLimit) => (input) => {
    let err = null;
    if (!input || !input.trim().length) {
        err = t('clearing-houses.validation.clearing-house-empty-default-cash-limit');
    } else if (input < minCashLimit) {
        err = t('clearing-houses.validation.clearing-house-default-cash-limit-too-low', { minCashLimit });
    } else if (input > maxCashLimit) {
        err = t('clearing-houses.validation.clearing-house-default-cash-limit-too-high', { maxCashLimit });
    }
    return err;
};
